export default __webpack_public_path__ + "static/media/705.205abcb4.gif";